<template>
  <div class="helpConfigBar">
    <v-sheet class="helpConfigBar_main">
      <div class="helpConfigBar_title">
        <div class="helpConfigBar_title_text">お問い合わせ</div>
      </div>
      <div class="helpConfigBar_events_container">
        <div class="helpConfigBar_events">
          <config-bar-link
            v-for="(setting, i) in helps"
            :key="`helps-link-${i}`"
            :setting="setting"
            :active="setting.key === activeSetting"
          />
          <v-divider class="helpConfigBar_divider" />
        </div>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import ConfigBarLink from '@/components/settings/ConfigBarLink.vue';
import { mapState } from 'vuex';
export default {
  name: 'HelpConfigBar',
  components: {
    ConfigBarLink,
  },
  computed: {
    ...mapState({
      helpCategories: (state) => state.help.categories,
    }),
    activeSetting() {
      return this.$route.params.parent;
    },
    helps() {
      return this.helpCategories.map((item) => ({
        title: item.title,
        desc: item.Description,
        to: { name: 'help-cat', params: { id: item.id } },
      }));
    },
  },
};
</script>

<style lang="scss">
.helpConfigBar {
  &_notification {
    &.v-sheet.theme--light {
      .helpConfigBar & {
        flex-grow: 0;
        margin-bottom: 30px;
        color: #fff;
        background-color: var(--primary-color);
        padding-bottom: 16px;
        box-shadow: 0 3px 12px 0 rgba(0, 45, 170, 0.19);
      }
    }
    &_supTitle {
      font-size: 14px;
      font-weight: 600;
      line-height: 17px;
      margin-bottom: 7px;
    }
    &_title {
      font-size: 16px;
      font-weight: 600;
      line-height: 21px;
      margin-bottom: 2px;
    }
    .eventItem {
      border-top: 0;
      padding-left: 0;
      padding-right: 0;
    }
    .eventItem_time {
      color: #fff;
    }
    .eventItem_date {
      font-weight: 400;
    }
    .eventItem_hour {
      font-weight: 400;
    }
    .eventItem_chevron {
      display: none;
    }
  }
  &_main {
    &.v-sheet {
      padding-right: 22px;
    }
  }
  &.v-sheet {
    padding-right: 22px;
  }
  &_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 17px;
    padding-right: 8px;
    &_text {
      font-size: 14px;
      font-weight: 600;
      color: var(--text-color);
    }
    &_btn {
      .icon {
        margin-left: 8px;
        position: relative;
        margin-right: -5px;
        position: relative;
      }
    }
    &_icon {
      &-open {
        transform: rotate(180deg);
      }
    }
  }
  &_divider {
    border-color: #ccc;
  }
  &_events {
    padding-right: 8px;
    &_container {
    }
  }
}
</style>
